import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import './Expression.scss'
import hosts from '../Hosts/animals.json';
import { pathogen } from '../Hosts/pathogen.js';
import { env } from '../../env';
import { Divider, Button } from "antd";
import axios from "axios";
import { useParams } from "react-router-dom";
import test from "../Interactome/test.gif";

export default function SelectExpression() {
  const { host: hostUnderscores, pathogen: pathogenUnderscores, protein } = useParams();
  const [hostCommon, setHostCommon] = useState('');
  const [hostSpaces, setHostSpaces] = useState('');
  const [pathogenSpaces, setPathogenSpaces] = useState('');
  const [experimentData, setExperimentData] = useState([]);
  const [selectedExperiment, setSelectedExperiment] = useState('');
  const [calculating, setCalculating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fdr, setFdr] = useState(0.05);
  const [fold, setFold] = useState(1.5);

  const handleRadioChange = (e) => {
    setSelectedExperiment(e);
  }

  const getPathogenSpecies = () => {
    return pathogen[pathogenUnderscores];
  };

  const getHostSpecies = () => {
    console.log(hostUnderscores.replace('_', ' '))
    return hosts.find(item => item.sname === hostUnderscores.replace('_', ' ')).name
  };

  const getExpression = () => {
    if (selectedExperiment === '') {
      alert('Please, select an experiment.')
      return;
    }
    setCalculating(true);
    const postBody = {
      host: hostUnderscores,
      pathogen: pathogenUnderscores,
      experiment: selectedExperiment,
      fdr: fdr,
      fold: fold,
    }
    axios
        .post(`${env.BACKEND}/api/expression/calculateExpression/`, postBody)
        .then((res) => {
          if (res.data) {
            window.location.replace(`${env.BASE_URL}/expression/${hostUnderscores}/${pathogenUnderscores}/${selectedExperiment}/${fdr}/${fold}`);
          } else {
            alert('Sorry, there was an error. Please, contact us.')
          }
        })
        .catch((err) => {
          setCalculating(false);
          console.error(`Request for experiment ${selectedExperiment} failed`, err.response);
        })
  }

  const fetchGeoTitle = async (accession) => {
    try {
      if (!accession.startsWith('E-')) {
        // Make an API request to retrieve the metadata of the GEO experiment
        const response = await fetch(`https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=${accession}&targ=self&form=xml&view=brief`);
        const xmlData = await response.text();

        // Parse the XML response to extract the title
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlData, 'text/xml');
        const title = xmlDoc.querySelector('Title').textContent;

        return title;
      } else {
        const response = await fetch(`https://www.ebi.ac.uk/biostudies/api/v1/studies/${accession}`);
        if (!response.ok) throw new Error('Experiment not found');

        const data = await response.json();

        // Title is typically in the "title" field
        const titleAttr = data.attributes.find(attr => attr.name === 'Title');
        return titleAttr ? titleAttr.value : null;
      }
    } catch (error) {
        console.error("Error fetching GEO experiment title:", error);
        return null;
    }
};

  const getExperiments = async () => {
    let url = `${env.BACKEND}/api/expression/checkExperiments?folder=${hostUnderscores}_${pathogenUnderscores}`;
    if (protein) {
      url += `&protein=${protein}`;
    }
    const result = await axios.get(url);
    let experimentsList = [];
    const data = result.data;
    if (data.hasOwnProperty('experiments')) {
      experimentsList = result.data.experiments.map(exp => ({id: exp, color: 'none'}));
    } else if (data.hasOwnProperty('downExperiments') && data.hasOwnProperty('upExperiments')) {
      experimentsList = [];
      for (let i = 0; i < data.downExperiments.length; i++) {
        experimentsList.push({id: data.downExperiments[i], color: '#f3cbcb'});
      }
      for (let i = 0; i < data.upExperiments.length; i++) {
        experimentsList.push({id: data.upExperiments[i], color: '#b2dbb5'});
      }
    }

    for (let i = 0; i < experimentsList.length; i++) {
      const experimentId = experimentsList[i].id;
      experimentsList[i].title = await fetchGeoTitle(experimentId);
      if (experimentId.startsWith('GSE')) {
        experimentsList[i].url = 'https://www.ncbi.nlm.nih.gov/geo/query/acc.cgi?acc=' + experimentId;
      }
      else {
        experimentsList[i].url = 'https://www.ebi.ac.uk/biostudies/arrayexpress/studies/' + experimentId;
        
      }
    }
    setLoading(false);
    return experimentsList;
  }

  // eslint-disable-next-line
  useEffect(() => {
    const fetchData = async () => {
      setPathogenSpaces(getPathogenSpecies(pathogenUnderscores));
      const foundHost = getHostSpecies();
      setHostCommon(foundHost);
      setHostSpaces(hostUnderscores.replaceAll('_', ' '));
      const experimentsList = await getExperiments();
      setExperimentData(experimentsList);
    };

    fetchData();
  // eslint-disable-next-line
  }, [hostUnderscores, pathogenUnderscores]);

  return (
    <div className="container">
      <Divider />
      <div className="row flex-lg-row align-items-center ">
        <h5> <b>Host:</b> {hostCommon} (<i>{hostSpaces}</i>) &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <b>Pathogen:</b> <i>{pathogenSpaces}</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;</h5>
        <Divider />
        <div className="col-md-1">
        </div>
        <div className="col-md-3">
          <div className="d-flex align-items-center">
            <label className="label-text col-md-4 mr-2">FDR</label>
            <input
              className="form-control"
              type="number" min="0" max="1" step="0.05"
              value={fdr} onChange={e => setFdr(e.target.value)}
            ></input>
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="label-text col-md-6 mr-2">Log2 Fold Change</label>
            <input
              className="form-control"
              type="number" step="0.1"
              value={fold} onChange={e => setFold(e.target.value)}
            ></input>
          </div>
        </div>
        <div className="col-md-4">
          <Button
            type="primary"
            shape="square"
            size="large"
            onClick={getExpression}
          >
            Get Expression Data{" "}
          </Button>
        </div>
        <div className="row flex-lg-row justify-content-center g-2 my-3">
        {calculating && (
            <div className="col-md-8">
              <h5 className="mb-3">Please wait. The expression data is being processed.</h5>
              <img src={test} className="loading" height="50px" alt=""></img>
            </div>
          )}
        </div>
        <Table responsive className="kbl-table table-borderless">
          <thead className="kbl-thead">
            <tr>
              <th></th>
              <th>Experiment</th>
              <th>Title</th>
              <th>URL</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={4}>
                  <img src={test} className="loading" height="50px" alt=""></img>
                </td>
              </tr>
            )}
            {!loading && experimentData.length === 0 && (
              <tr>
              <td colSpan={4}>
                No experiments were found where genes for protein {protein} are differentially expressed.
              </td>
            </tr>
            )}
            {experimentData.map((result, index) => (
              <tr
                key={result.id}
                className="clickable-row"
                onClick={() => handleRadioChange(result.id)}
                style={{ backgroundColor: result.color }}
              >
                <td style={{ paddingLeft: "20px", transform: "translateY(1px)" }}>
                  <input
                    type="radio"
                    name="experimentSelection"
                    value={result.id}
                    checked={selectedExperiment === result.id}
                    onChange={() => handleRadioChange(result.id)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </td>
                <td>{result.id}</td>
                <td>{result.title}</td>
                <td><a target="_blank" rel="noreferrer" className="host" href={result.url}>NCBI GEO page</a></td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Divider />
      </div>
    </div>
  );
}
